import { render } from "./DocView.vue?vue&type=template&id=bba7e5c6"
import script from "./DocView.vue?vue&type=script&lang=js"
export * from "./DocView.vue?vue&type=script&lang=js"

import "./DocView.vue?vue&type=style&index=0&id=bba7e5c6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__